export const WEBSITE_LOGO = require('@/assets/images/zelfPOS-logo.png');
export const DEFAULT_CATEGORY_IMAGE = require('@/assets/images/no-image-found.png');
export const DEFAULT_PRODUCT_IMAGE = require('@/assets/images/no-image-found.png');
export const DEFAULT_TABLE_IMAGE = require('@/assets/images/left-nav-images/table.png');
export const PROMPTPAY_IMAGE = require('@/assets/images/prompt-pay-logo.png');